<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout>
        <v-flex>
          <v-btn @click="back()">Back</v-btn>
          <v-btn @click="goToLive()" color="indigo darken-4" dark v-if="match && match.beachMatch.liveStreamUri">
            <v-icon dark left>live_tv</v-icon>Watch Live
          </v-btn>
        </v-flex>
        <!-- <v-layout align-center>
          <v-flex xs4>
            <v-text-field label="Hostname" v-model="hostnameField"></v-text-field>
          </v-flex>
          <v-btn small @click="setHostname()">Set</v-btn>
        </v-layout> -->
      </v-layout>
    </v-container>

    <v-container v-if="!live" fluid fill-height justify-center align-center>
      <v-progress-circular indeterminate color="indigo darken-4"></v-progress-circular>
    </v-container>

    <v-container v-if="live" fluid wrap grid-list-md text-xs-center>
      <v-layout v-bind="binding" wrap fill-height>
        <v-flex id="left-block" xs6 wrap>
          <v-flex>
            <v-card wrap>
              <v-card-title primary-title style="display: flex; align-items: center; justify-content: space-between">
                <h2>{{ `${match.beachMatch.noInTournament}`.padStart(3, '0') }} - {{ teamA.name }} vs {{ teamB.name }}</h2>
                <div>
                  <v-chip label medium color="indigo darken-4" text-color="white">
                    <v-icon left>label</v-icon>{{ status[match.status] }}
                  </v-chip>
                </div>
              </v-card-title>
              <v-data-table :items="[]" hide-actions hide-headers disable-initial-sort>
                <template slot="no-data">
                  <tr>
                    <th></th>
                    <th>Score</th>
                    <th v-for="(set) in live.sets" :key="set.no">{{set.no}}</th>
                    <th></th>
                    <th v-for="i in (5 - live.sets.length)" :key="i + live.sets.length"></th>
                    <th>Total</th>
                  </tr>
                  <tr>
                    <td style="display: flex; align-items: center">
                      <f-flag :code="teamA.federationCode"></f-flag>
                      <strong>{{ teamA.name }}</strong>
                    </td>
                    <td>
                      <strong>{{ match.matchPointsA }}</strong>
                    </td>
                    <td v-for="(set, index) in live.sets" :key="set.no">
                      {{ set.pointsTeamA }}
                      <svg v-if="live.noServingTeam === teamA.no && live.sets.length === index + 1" style="height: 14px; position: absolute; margin-left: 10px; margin-top: 1px" enable-background="new 0 0 30 26.6" viewBox="0 0 30 26.6" xmlns="http://www.w3.org/2000/svg"><path d="m15 0c-7.3 0-13.3 6-13.3 13.3s6 13.3 13.3 13.3 13.3-6 13.3-13.3-6-13.3-13.3-13.3zm10.8 18.3c-2.7-5.1-8-5.7-10.1-5.7 0-.9.2-2.6 1-4.4 1.6-.1 7.5-.1 10.2 5.6-.1 1.6-.5 3.1-1.1 4.5zm-11.3 6.9c-1.6-.1-3.2-.5-4.5-1.1 5-2.7 5.7-8.1 5.7-10.1.8 0 2.4.2 4 .8.1.9.6 7.4-5.2 10.4zm-10.3-16.9c2.7 5.1 8.1 5.7 10.1 5.7 0 .9-.2 2.7-1 4.6-1.4.1-7.3.2-10.2-5.3 0-1.8.4-3.5 1.1-5zm11.4-6.9c1.6.1 3.1.5 4.4 1.1-5.1 2.7-5.7 8-5.7 10.1-.9 0-2.5-.2-4.2-.9-.1-1.4-.2-7.5 5.5-10.3zm11.2 10.8c-2.8-4.5-7.7-4.8-9.8-4.8.9-1.6 2.3-3.1 4.5-4 3 1.9 5 5.1 5.3 8.8zm-12.7-10.7c-4.6 2.9-4.9 8-4.8 9.9-1.6-.8-3.3-2.3-4.3-4.6 2.1-3 5.4-5.1 9.1-5.3zm-10.9 13.4c2.7 3.9 7 4.5 9.2 4.5h.5c-.9 1.5-2.2 3-4.5 3.9-2.8-1.9-4.7-5-5.2-8.4zm12.7 10.2c4.6-3.1 4.7-8.3 4.5-10 1.7.8 3.4 2.3 4.4 4.7-1.9 3-5.1 5-8.9 5.3z" fill="#1d1d1b"/></svg>
                    </td>
                    <td>
                      <v-chip v-if="live.isSetPointTeamA" label small color="indigo darken-4" text-color="white">{{ live.isMatchPointTeamA ? 'Match' : 'Set' }} Point #{{ live.isSetPointTeamA }}</v-chip>
                    </td>
                    <td v-for="i in (5 - live.sets.length)" :key="i + live.sets.length"></td>
                    <td>
                      {{ live.sets.reduce((i, set) => i + set.pointsTeamA, 0) }}
                    </td>
                  </tr>
                  <tr>
                    <td style="display: flex; align-items: center">
                      <f-flag :code="teamB.federationCode"></f-flag>
                      <strong>{{ teamB.name }}</strong>
                    </td>
                    <td>
                      <strong>{{ match.matchPointsB }}</strong>
                    </td>
                    <td v-for="(set, index) in live.sets" :key="set.no">
                      {{ set.pointsTeamB }}
                     <svg v-if="live.noServingTeam === teamB.no && live.sets.length === index + 1" style="height: 14px; position: absolute; margin-left: 10px; margin-top: 1px" enable-background="new 0 0 30 26.6" viewBox="0 0 30 26.6" xmlns="http://www.w3.org/2000/svg"><path d="m15 0c-7.3 0-13.3 6-13.3 13.3s6 13.3 13.3 13.3 13.3-6 13.3-13.3-6-13.3-13.3-13.3zm10.8 18.3c-2.7-5.1-8-5.7-10.1-5.7 0-.9.2-2.6 1-4.4 1.6-.1 7.5-.1 10.2 5.6-.1 1.6-.5 3.1-1.1 4.5zm-11.3 6.9c-1.6-.1-3.2-.5-4.5-1.1 5-2.7 5.7-8.1 5.7-10.1.8 0 2.4.2 4 .8.1.9.6 7.4-5.2 10.4zm-10.3-16.9c2.7 5.1 8.1 5.7 10.1 5.7 0 .9-.2 2.7-1 4.6-1.4.1-7.3.2-10.2-5.3 0-1.8.4-3.5 1.1-5zm11.4-6.9c1.6.1 3.1.5 4.4 1.1-5.1 2.7-5.7 8-5.7 10.1-.9 0-2.5-.2-4.2-.9-.1-1.4-.2-7.5 5.5-10.3zm11.2 10.8c-2.8-4.5-7.7-4.8-9.8-4.8.9-1.6 2.3-3.1 4.5-4 3 1.9 5 5.1 5.3 8.8zm-12.7-10.7c-4.6 2.9-4.9 8-4.8 9.9-1.6-.8-3.3-2.3-4.3-4.6 2.1-3 5.4-5.1 9.1-5.3zm-10.9 13.4c2.7 3.9 7 4.5 9.2 4.5h.5c-.9 1.5-2.2 3-4.5 3.9-2.8-1.9-4.7-5-5.2-8.4zm12.7 10.2c4.6-3.1 4.7-8.3 4.5-10 1.7.8 3.4 2.3 4.4 4.7-1.9 3-5.1 5-8.9 5.3z" fill="#1d1d1b"/></svg>
                    </td>
                    <td>
                      <v-chip v-if="live.isSetPointTeamB" label small color="indigo darken-4" text-color="white">{{ live.isMatchPointTeamB ? 'Match' : 'Set' }} Point #{{ live.isSetPointTeamB }}</v-chip>
                    </td>
                   <td v-for="i in (5 - live.sets.length)" :key="i + live.sets.length"></td>
                   <td>
                      {{ live.sets.reduce((i, set) => i + set.pointsTeamB, 0) }}
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      <v-icon>alarm</v-icon>
                    </td>
                    <td v-for="set in live.sets" :key="set.no">
                      {{ calculateDuration(set.duration) }}
                    </td>
                   <td v-for="i in (5 - live.sets.length)" :key="i + live.sets.length"></td>
                   <td></td>
                   <td>
                     {{ calculateDuration(totalTime) }}
                   </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
          <v-flex>
            <play-by-play
              :teamA="teamA"
              :teamB="teamB"
              :events-by-set="events"
              :players="players"
              :teams="teams"
            ></play-by-play>
          </v-flex>
        </v-flex>
        <v-flex id="right-block" xs6 wrap>
          <v-flex>
            <statistics-by-team
              :statistics="live.sets.map(set => set.teamStatistics)"
              :teams="teams"
            ></statistics-by-team>
          </v-flex>
          <v-flex>
            <statistics-by-player
              :statistics-per-set="live.sets.map(set => set.playerStatistics)"
              :statistics="match.playerStatistics"
              :teams="teams"
            ></statistics-by-player>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Flag from '@/components/Flag'
import { Request } from '@fivb/sdk'
import { normalize, schema } from 'normalizr'
import _ from 'lodash'
import MatchStatus from '@/matchStatus'

import PlayByPlay from '@/components/MatchLive/PlayByPlay/PlayByPlay'
import StatisticsByTeam from '@/components/MatchLive/StatisticsByTeam/StatisticsByTeam'
import StatisticsByPlayer from '@/components/MatchLive/StatisticsByPlayer/StatisticsByPlayer'

const matchSchema = new schema.Entity('match', {
  beachMatch: beachMatchSchema,
}, { idAttribute: 'no' })

const beachMatchSchema = new schema.Entity('beachMatch', {}, { idAttribute: 'no' })
const tournamentSchema = new schema.Entity('tournament', {}, { idAttribute: 'no' })
const playerSchema = new schema.Entity('player', {}, { idAttribute: 'no' })

const teamSchema = new schema.Entity('team', {
  players: [playerSchema]
}, { idAttribute: 'no' })

export default {
  components: {
    'play-by-play': PlayByPlay,
    'statistics-by-team': StatisticsByTeam,
    'statistics-by-player': StatisticsByPlayer,
    'f-flag': Flag,
  },

  data: () => ({
    timeOutId: null,
    topToBottom: true,
    live: null,
    match: null,
    status: MatchStatus,
    events: [],
    teams: [],
    teamA: {},
    teamB: {},
    players: [],
    rallies: [],
    version: 0,
    hostname: process.env.VUE_APP_FIVB_API_HOST,
    hostnameField: process.env.VUE_APP_FIVB_API_HOST,
  }),

  created () {
    this.proceedUpdate()
  },

  beforeDestroy () {
    this.$store.commit('removeMatchLiveInformation')
    clearTimeout(this.timeOutId)
  },

  computed: {
    binding () {
      const binding = {}

      if (this.$vuetify.breakpoint.smAndDown) binding.column = true

      return binding
    },

    totalTime () {
      return this.live.sets.reduce((value, set) => value + set.duration, 0)
    },

    sortedRallies () {
      if (this.topToBottom) {
        return this.rallies.slice().reverse()
      }

      return this.rallies
    },
  },

  methods: {
    setHostname () {
      clearTimeout(this.timeOutId)
      this.hostname = this.hostnameField
      this.version = 0
      this.proceedUpdate()
    },

    goToLive () {
      window.open(this.match.beachMatch.liveStreamUri, '_blank')
    },

    isTeamA (id) {
      return this.teamA.players.indexOf(id) != -1
    },

    isTeamB (id) {
      return this.teamB.players.indexOf(id) != -1
    },

    async proceedUpdate () {
      const request = new Request('GetBeachLive')
        .addAttribute('No', this.$route.params.id)
        .addAttribute('Options', 65535)
        .addAttribute('Version', this.version)
        .toString()

      const { data } = await this.fetchData(request)
      const live = data.beachLive

      if (live === undefined) {
        this.timeOutId = setTimeout(this.proceedUpdate, 8000)
        return
      }
      // const normalizedData = normalize(live, {
      //   match: matchSchema,
      //   teams: [teamSchema],
      //   tournament: tournamentSchema,
      // })

      this.live = live
      this.match = this.live.match
      // this.match = normalizedData.entities.match[normalizedData.result.match]
      this.teamA = this.live.teams.find(t => t.no === this.match.noTeamA)
      // this.teamA = normalizedData.entities.team[this.match.noTeamA]
      this.teamB = this.live.teams.find(t => t.no === this.match.noTeamB)
      // this.teamB = normalizedData.entities.team[this.match.noTeamB]

      this.teams = {
        [this.match.noTeamA]: this.teamA,
        [this.match.noTeamB]: this.teamB,
      }

      // this.teams = normalizedData.entities.team
      this.players = {
        ...this.live.teams[0].players.reduce((acc, curr) => {
          acc[curr.no] = curr
          return acc
        }, {}),

        ...this.live.teams[1].players.reduce((acc, curr) => {
          acc[curr.no] = curr
          return acc
        }, {})
      }
      // ...this.live.teams[0].players, ...this.live.teams[1].players]
      // this.players = normalizedData.entities.player

      this.events = _.map(this.live.sets, set => ({ events: set.events, lineUps: set.lineUps }))
      this.rallies = _.flatMap(this.live.sets, set => set.events)

      this.version = this.live.version

      this.$store.commit('setMatchLiveInformation', {
        players: this.players,
        match: this.match,
        tournament: this.live.tournament, // normalizedData.entities.tournament[normalizedData.result.tournament],
      })

      if (this.match.status < 25) {
        this.timeOutId = setTimeout(this.proceedUpdate, 8000)
      }
    },

    calculateDuration (duration) {
      const hours = Math.floor(duration / 3600)

      const minutes = duration > 3600
        ? Math.floor((duration % 3600) / 60)
        : Math.floor(duration / 60)

      return `${hours}:${minutes.toString().padStart(2, 0)}`
    },

    back () {
      this.$router.push({ name: 'TournamentMatchList', params: { id: this.live.tournament.no } })
    },

    async fetchData (query) {
      return (await fetch(process.env.VUE_APP_FIVB_API_URL, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-store',
        headers: new Headers({
          'Content-Type': 'application/xml',
          'Accept': 'application/json',
          'X-FIVB-App-ID': '3b665ad61056495ab5514b81eb0562d8'
        }),
        body: query,
      }).then(response => response.json()))
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/components/MatchLive.vue